import { h, Component } from 'preact'
import style from './index.scss'

const getClientPos = e => {
  let pageX, pageY

  if (e.touches) {
    pageX = e.touches[0].pageX
    pageY = e.touches[0].pageY
  } else {
    pageX = e.pageX
    pageY = e.pageY
  }

  return {pageX, pageY}
}

const easeOutCubic = (t) => (--t) * t * t + 1

class Scrollable extends Component {
  saveContainer = ref => this.container = ref
  saveContent = ref => this.content = ref

  scroll = {
    time: 0,
    start: 0,
    target: 0,
    current: 0
  }

  componentDidUpdate(prevProps) {
    if (this.props.updates !== prevProps.updates) {
      setTimeout(this.scrollToEnd, 100)
    }
  }

  scrollFrame = () => {
    const {time, start, target, current} = this.scroll
    if (current < 1) {
      const nextTime = Date.now()
      const deltaTime = nextTime - time
      const delta = deltaTime / 100
      const scrollProgress = easeOutCubic(Math.min(this.scroll.current += delta, 1))
      window.scroll(0, start + scrollProgress * (target - start))
      this.scroll.time = nextTime
      requestAnimationFrame(this.scrollFrame)
    }
  }

  smothScroll(target) {
    const start = window.scrollY
    this.scroll = {
      start,
      target,
      current: 0,
      time: Date.now()
    }
    this.scrollFrame()
  }

  scrollToEnd = () => {
    const {content, container} = this
    const diff = content.clientHeight - window.innerHeight
    const offset = Math.max(0, diff)
    this.smothScroll(offset)
  }

  render({children}) {
    return (
      <div ref={this.saveContainer} class={style.normal}>
        <div ref={this.saveContent} class={style.content}>
          {children}
        </div>
      </div>
    )
  }
}

export default Scrollable



// WEBPACK FOOTER //
// ./components/Scrollable/index.js